<template>
  <div>
    <div v-if="loading" class="row">
      <div v-for="n in skeletonCount"
           :key="`skeleton-${n}`"
           class="col-6 col-sm-6 col-lg-4 col-xl-3">
        <div class="collage-photo-item">
          <div class="collage-photo-item__image-container is-loading"></div>
        </div>
      </div>
    </div>

    <div v-else-if="!media || media.length === 0" class="no-media">
      <p>No purchased media available</p>
    </div>

    <div v-else>
      <div class="row">
        <div v-for="(item, index) in media"
             :key="item.id"
             class="col-6 col-sm-6 col-lg-4 col-xl-3 purchased">

          <MediaItem :index="index"
                     :media="item"
                     :gallery="gallery"
                     :favorite-enabled="favoriteEnabled"
                     @toggle-favorite="toggleFavourite"
                     @select="$emit('open-media', $event)"/>
        </div>
      </div>

      <Pagination :total-pages="totalPages"
                  :currentPage="currentPage"
                  :paginationSize="paginationSize"
                  :paginationType="paginationType"
                  :loadingMore="loadingMore"
                  @load-more="$emit('load-more')"
                  @change-page="$emit('change-page', $event)"/>
    </div>


  </div>
</template>

<script>
import MediaItem from "@/domain/galleryTree/components/MediaItem.vue";
import Pagination from "@/domain/galleryTree/components/Pagination.vue";

export default {
  name: 'VerticalPurchased',
  components: {Pagination, MediaItem},

  props: {
    gallery: {
      type: Object,
      required: true
    },
    media: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: 'purchased'
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    paginationSize: {
      type: Number,
      default: 20
    },
    paginationType: {
      type: String,
      default: 'pagination'
    },
    favoriteEnabled: {
      type: Boolean,
      default: false
    },
    totalMedia: {
      type: Number,
      default: 0
    }
  },
  computed: {
    skeletonCount() {
      if (this.totalMedia && this.totalMedia > 0) {
        return Math.min(this.paginationSize, this.totalMedia)
      }
      return this.paginationSize
    }
  },
  methods: {
    toggleFavourite(item) {
      if (item.favorite) {
        this.$emit('remove-from-favourites', item.id)
      } else {
        this.$emit('add-to-favourites', item.id)
      }
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    }
  }
}
</script>